// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"data-table2_wrapper__20shh","top":"data-table2_top__v0E9G","title":"data-table2_title__3_Hug","actions":"data-table2_actions__1jdSy"};